import React from 'react';
import CustomTooltip from '../../Utils/CustomTooltip';

const Bio = ({ bio }) => {
  // Only render if bio exists and is not auto-generated
  if (!bio?.bio || bio.bio === "[AUTO-GENERATED]") {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow" style={{ overflow: 'visible', borderRadius: '0.5rem' }}>
      <div className="px-6 py-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          Professional Summary
          {bio.rationale && (
            <CustomTooltip 
              content={bio.rationale}
              className="text-lg"
            >
              <span className="ml-2 text-sm text-gray-500 cursor-help">
                (hover for rationale)
              </span>
            </CustomTooltip>
          )}
        </h3>
        <p className="text-gray-700 whitespace-pre-line">{bio.bio}</p>
      </div>
    </div>
  );
};

export default Bio;
